<template>
    <Modal
      event-tracking-source="maintenance plan info popup"
      class="downgrade-modal"
      @close="$emit('close')"
    >
        <h2 slot="header" class="text-ma-red-1 text-2xl mb-2 text-center sm:text-left">Wait!</h2>

        <p class="text-base mb-4">If you cancel, you are legally no longer allowed to use your downloaded files in new projects. Are you sure you want to downgrade?</p>

        <div slot="footer">
            <a href="/account/upgrade" class="inline-block w-full sm:w-32 mr-2 p-2 font-semibold text-center bg-ma-red-1 hover:bg-ma-red-2 text-white hover:text-white text-sm capitalize">
                No thanks
            </a>
            <div class="text-sm mt-2 text-center sm:mt-0 sm:text-left sm:inline">
                or
                <a @click="$emit('downgrade')" class="cursor-pointer">
                    <div class="animation-spin btn-spinner inline-block ml-2" v-show="loading" v-cloak>
                        <i class="icon-spinner2"></i>
                    </div>
                    Yes, downgrade my account
                </a>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
    components: {
        Modal
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style scoped>
    ::v-deep .modal-container {
        width: 460px;
        padding: 20px 30px;
    }
</style>
